import * as React from 'react';

export const About = () => {
    return (
        <div className="container">
            <h2>About</h2>
            <h3>About CRANNE</h3>
            <img src="/images/logo.png" alt="Logo" width="233" height="266" />

            <p>C.R.A.N.N.E. came together in 1998 when Hobie Fleet 209 and Prindle Fleet 80, a mixed catamaran fleet from all over northern New England merged. A new fleet name was established to represent this truly mixed fleet of beach catamarans sailing enthusiasts.</p>
            <p>We are a family friendly group and have several events that the fleet for both the recreational sailor as well as competitive sailor. During the summer months we hold events at Sebago Lake State park in Casco ME. These events are great family orientated events that include tent camping as well as wonderful fresh water sailing. At night we kick back by the campfire and tell tales of great sailing while roasting marshmallows .</p>
            <p>C.R.A.N.N.E. volunteers staff the Hampton Beach Regatta held in each June. We also have a "Homeport" regatta which is hosted at the home of one of our fleet members at Great Pond in Belgrade Lakes ME. We race during the day then come back in and have a summer New England lobster feast. Due to the space and financial reasons, we reserve this regatta to fleet members only. Anyone interested in beach catamaran sailing in New England are encouraged to join us.</p>
        </div>
    );
}

export default About;
